import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchConversation = createAsyncThunk(
  "messagerie/fetchConversation",
  async ({ userId1, userId2 }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/messagerie/conversation/${userId1}/${userId2}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur chargement");
    }
  }
);

export const fetchUnreadMessages = createAsyncThunk(
  "messagerie/fetchUnread",
  async (destinataireId, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/messagerie/non-lus/${destinataireId}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur chargement");
    }
  }
);

export const envoyerMessage = createAsyncThunk(
  "messagerie/envoyer",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post("/messagerie", formData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur envoi");
    }
  }
);

export const marquerLu = createAsyncThunk(
  "messagerie/marquerLu",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.patch(`/messagerie/${id}/lire`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur lecture");
    }
  }
);

export const deleteMessage = createAsyncThunk(
  "messagerie/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/messagerie/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur suppression");
    }
  }
);

const messagerieSlice = createSlice({
  name: "messagerie",
  initialState: {
    conversation: [],   // messages between 2 users
    unread:       [],   // unread messages
    loading:      false,
    error:        null,
    success:      null,
  },
  reducers: {
    clearMessagerieMessages: (state) => { state.error = null; state.success = null; },
    clearConversation:       (state) => { state.conversation = []; },
  },
  extraReducers: (builder) => {
    builder
      // fetchConversation
      .addCase(fetchConversation.pending,   (state) => { state.loading = true; state.error = null; })
      .addCase(fetchConversation.fulfilled, (state, action) => {
        state.loading = false;
        state.conversation = Array.isArray(action.payload) ? action.payload : (action.payload.data || []);
      })
      .addCase(fetchConversation.rejected,  (state, action) => { state.loading = false; state.error = action.payload; })

      // fetchUnreadMessages
      .addCase(fetchUnreadMessages.fulfilled, (state, action) => {
        state.unread = Array.isArray(action.payload) ? action.payload : (action.payload.data || []);
      })

      // envoyerMessage
      .addCase(envoyerMessage.fulfilled, (state, action) => {
        state.conversation.push(action.payload);
        state.success = "Message envoyé.";
      })
      .addCase(envoyerMessage.rejected, (state, action) => { state.error = action.payload; })

      // marquerLu
      .addCase(marquerLu.fulfilled, (state, action) => {
        // remove from unread
        state.unread = state.unread.filter((m) => m._id !== action.payload._id);
        // update in conversation
        const idx = state.conversation.findIndex((m) => m._id === action.payload._id);
        if (idx !== -1) state.conversation[idx] = action.payload;
      })

      // deleteMessage
      .addCase(deleteMessage.fulfilled, (state, action) => {
        state.conversation = state.conversation.filter((m) => m._id !== action.payload);
        state.unread       = state.unread.filter((m) => m._id !== action.payload);
        state.success      = "Message supprimé.";
      })
      .addCase(deleteMessage.rejected, (state, action) => { state.error = action.payload; });
  },
});

export const { clearMessagerieMessages, clearConversation } = messagerieSlice.actions;
export default messagerieSlice.reducer;
